import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 2c-.265 0-.52.105-.707.293C5.105 2.48 5 2.735 5 3v1H4c-.53 0-1.04.21-1.414.586C2.21 4.96 2 5.47 2 6v10c0 .53.21 1.04.586 1.414C2.96 17.79 3.47 18 4 18h12c.53 0 1.04-.21 1.414-.586C17.79 17.04 18 16.53 18 16V6c0-.53-.21-1.04-.586-1.414C17.04 4.21 16.53 4 16 4h-1V3c0-.265-.105-.52-.293-.707C14.52 2.105 14.265 2 14 2c-.265 0-.52.105-.707.293C13.105 2.48 13 2.735 13 3v1H7V3c0-.265-.105-.52-.293-.707C6.52 2.105 6.265 2 6 2zm0 5c-.265 0-.52.105-.707.293C5.105 7.48 5 7.735 5 8c0 .265.105.52.293.707C5.48 8.895 5.735 9 6 9h8c.265 0 .52-.105.707-.293C14.895 8.52 15 8.265 15 8c0-.265-.105-.52-.293-.707C14.52 7.105 14.265 7 14 7H6z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17 3.94737C17 3.42632 16.55 3 16 3C15.45 3 15 3.42632 15 3.94737H9C9 3.42632 8.55 3 8 3C7.45 3 7 3.42632 7 3.94737H6C4.35 3.94737 3 5.22632 3 6.78947V18.1579C3 19.7211 4.35 21 6 21H18C19.65 21 21 19.7211 21 18.1579V6.78947C21 5.22632 19.65 3.94737 18 3.94737H17ZM8 7.73684C7.45 7.73684 7 7.31053 7 6.78947V5.84211H6C5.45 5.84211 5 6.26842 5 6.78947V9.63158H19V6.78947C19 6.26842 18.55 5.84211 18 5.84211H17V6.78947C17 7.31053 16.55 7.73684 16 7.73684C15.45 7.73684 15 7.31053 15 6.78947V5.84211H9V6.78947C9 7.31053 8.55 7.73684 8 7.73684ZM5 11.5263H19V18.1579C19 18.6789 18.55 19.1053 18 19.1053H6C5.45 19.1053 5 18.6789 5 18.1579V11.5263Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.fill)
    ? (_openBlock(), _createBlock("svg", _hoisted_1, [
        _hoisted_2
      ]))
    : (_openBlock(), _createBlock("svg", _hoisted_3, [
        _hoisted_4
      ]))
}